/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import { ScrollEvents, Event } from '../scrollevent/component.js'
import brok from 'brokjson'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/checkbox.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'

import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import AnimatedMap from '../animatedmap/component.js'
import Entry from '../entry'
const scrollToElement = require('scroll-to-element')
const turf = require('@turf/helpers')
const turfDistance = require('@turf/distance').default

const ARTICLE_ID = '17216299'

const geoJSON = brok.brok2geo(require('../data/data.brokjson'))
const gemeinden = require('../data/gemeinden.geojson')

export function AppComponent() {
  const [map, setMap] = useState(null)
  const [searchstring, setSearchstring] = useState('')
  const [features, setFeatures] = useState([])
  const [activeFeature, setActiveFeature] = useState(null)
  const [globals, setGlobals] = useState({ name: '', email: '' })
  const [mapReady, setMapReady] = useState(false)
  const [fetchApi, setFetchApi] = useState(false)
  const [scrollEventActive, setScrollEventActive] = useState(true)
  const [autofill, setAutofill] = useState([])
  const [position, setPosition] = useState(null)

  const loadAmount = 10

  useEffect(() => {
    if (!activeFeature) return

    map.easeTo({ center: activeFeature.geometry.coordinates, zoom: 14 })

    // Check if active feature already loaded
    const filter = features.filter(
      f => f.properties.id === activeFeature.properties.id
    )
    if (filter.length === 0) {
      const newFeature = geoJSON.features.find(
        f => f.properties.id === activeFeature.properties.id
      )
      setFeatures([...features, newFeature])

      // Work around: scrollToElement has no callback after finish. So stop EventScroller and start after certain seconds
      setScrollEventActive(false)

      scrollToElement('.loadmore')

      setTimeout(() => setScrollEventActive(true), 1500)
    }

    // Add active feature to map
    map
      .getSource('active')
      .setData({ type: 'FeatureCollection', features: [activeFeature] })
  }, [activeFeature])

  useEffect(() => {
    if (searchstring === '') {
      setAutofill([])
      return
    }
    const filter = gemeinden.features.filter(
      f =>
        f.properties.NAME.toLowerCase().indexOf(searchstring.toLowerCase()) >= 0
    )
    setAutofill(filter.slice(0, 5))
  }, [searchstring])

  useEffect(() => {
    // Scroll after search

    console.log(features.length)

    if (features.length === 0) return

    if (features.length <= loadAmount) scrollToElement('.results')
  }, [features])

  const calculateDistance = coords => {
    const pFrom = turf.point(coords)

    for (const i in geoJSON.features) {
      const f = geoJSON.features[i]
      const pTo = turf.point(f.geometry.coordinates)
      const distance = turfDistance(pFrom, pTo, { units: 'meters' })
      f.properties.distance = Math.round(distance)
    }

    // Sort Array
    geoJSON.features.sort((a, b) =>
      a.properties.distance < b.properties.distance ? -1 : 1
    )

    // SetFeatures
    setFeatures(geoJSON.features.filter((f, i) => i < loadAmount))
  }

  useEffect(() => {
    if (position) {
      setAutofill([])
      calculateDistance([position[0], position[1]])
    }
  }, [position])

  const searchButton = () => {
    const filter = gemeinden.features.filter(
      f =>
        f.properties.NAME.toLowerCase().indexOf(searchstring.toLowerCase()) >= 0
    )
    if (filter.length === 1) {
      setSearchstring(filter[0].properties.NAME)
      setPosition(filter[0].geometry.coordinates)
    }
  }

  const loadMore = () => {
    setFeatures(
      geoJSON.features.filter((f, i) => i < features.length + loadAmount)
    )
  }

  // const search = () => {
  //   setFetchApi(true)

  //   // Debug
  //   // calculateDistance([8.548289, 47.366553])

  //   fetch(
  //     `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(
  //       searchstring
  //     )}&key=AIzaSyBYw533nWFEPl-saZSshVh3GmvwPftqMBo`,
  //     {
  //       method: 'GET'
  //     }
  //   )
  //     .then(response => {
  //       return response.json()
  //     })
  //     .then(data => {
  //       setFetchApi(false)

  //       if (data.results.length > 0) {
  //         setSearchstring(data.results[0].formatted_address)
  //         const pos = data.results[0].geometry.location
  //         calculateDistance([pos.lng, pos.lat])
  //       }
  //     })
  // }

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Diese Zürcherinnen und Zürcher brauchen Hilfe
              <div className='sub header'>
                Wir haben unsere Leserschaft aufgefordert: Meldet euch bei uns,
                wenn Ihr Unterstützung braucht. Viele haben sich gemeldet. Jetzt
                suchen wir Helferinnen und Helfer.
              </div>
            </div>
          </h1>
        </div>
      </header>

      <div className='ui vertical segment intro'>
        <div className='ui text container formcontainer'>
          <div className='ui segment searchbox' style={{ minHeight: 'auto' }}>
            <h2>Vorübergehend geschlossen</h2>
            <p>
              Wir konnten hilfesuchenden Leserinnen und Leser bereits
              Helferinnen und Helfer vermitteln. Daher bleibt die Suchfunktion
              vorerst geschlossen. Hilfesuchende Personen können sich{' '}
              <a href='https://interaktiv.tagesanzeiger.ch/2020/zurich-hilft-erfassen/?nosome'>
                aber weiterhin registrieren
              </a>
              .
            </p>
            {/*           
            {!mapReady && (
              <div className='ui active inverted dimmer'>
                <div className='ui text loader'>Einen Moment bitte</div>
              </div>
            )}
            {mapReady && (
              <>
                <h2>Hilfesuchende in meiner Nähe anzeigen</h2>
                <div
                  className={`ui left icon input ${fetchApi ? 'loading' : ''}`}
                >
                  <i className='search icon' />
                  <input
                    type='text'
                    placeholder='Gemeindename'
                    value={searchstring}
                    onChange={e => setSearchstring(e.target.value)}
                    onKeyDown={e => {
                      if (e.key === 'Enter') searchButton()
                    }}
                  />
                  <div className='autofill'>
                    <ul>
                      {autofill.map(e => (
                        <li
                          key={e.properties.BFS}
                          data={e}
                          onClick={() => setPosition(e.geometry.coordinates)}
                        >
                          {e.properties.NAME}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div
                  className={`ui blue submit button ${
                    searchstring === '' ? 'disabled' : ''
                  }`}
                  onClick={searchButton}
                >
                  Suchen
                </div>
              </>
            )} */}
          </div>

          {/* <div className='hinweis'>
            <h2>Hinweis: </h2>
            <p>
              Am Dienstag, 26. März, konnten wir den Hilfesuchenden ihre Helfer
              zustellen. Daraufhin wurde die Datenbank bereinigt, weshalb sich
              zur Zeit nur wenige Hilfegesuche in der Datenbank befinden.
              Hilfesuchende{' '}
              <a href='https://interaktiv.tagesanzeiger.ch/2020/zurich-hilft-erfassen/?nosome'>
                {' '}
                können sich hier eintragen
              </a>
              .
            </p>
          </div> */}

          {/* <div className='ui segment searchbox' style={{ minHeight: 'auto' }}>
            {!mapReady && (
              <div className='ui active inverted dimmer'>
                <div className='ui text loader'>Einen Moment bitte</div>
              </div>
            )}
            {mapReady && (
              <>
                <h2>Hilfesuchende in meiner Nähe anzeigen</h2>
                <div
                  className={`ui left icon input ${fetchApi ? 'loading' : ''}`}
                >
                  <i className='search icon' />
                  <input
                    type='text'
                    placeholder='Zürichstrasse, Winterthur'
                    value={searchstring}
                    onChange={e => setSearchstring(e.target.value)}
                  />
                </div>
                <div
                  className={`ui blue submit button ${
                    searchstring === '' ? 'disabled' : ''
                  }`}
                  onClick={search}
                >
                  Suchen
                </div>
              </>
            )}
          </div> */}

          <div className='results'>
            <ScrollEvents
              eventParams={[]}
              options={{
                fireOnce: false,
                offset: -150,
                active: scrollEventActive
              }}
              reloader={features}
            >
              {features.map(f => {
                return (
                  <Event
                    id={'id_' + f.properties.id}
                    event={() => {
                      setActiveFeature(f)
                    }}
                    key={f.properties.id}
                  >
                    <Entry
                      {...f.properties}
                      globals={globals}
                      activeFeature={
                        activeFeature ? activeFeature.properties.id : ''
                      }
                      setGlobals={g => {
                        console.log(g)
                      }}
                      onClick={() => setActiveFeature(f)}
                    />
                  </Event>
                )
              })}
            </ScrollEvents>
            {features.length > 0 && geoJSON.features.length > features.length && (
              <span className='loadmore' onClick={loadMore}>
                Weitere anzeigen
              </span>
            )}
          </div>

          <h2>Ich brauche auch Unterstützung</h2>
          <p>
            Suchen Sie auch Unterstützung im Haushalt oder beim Einkaufen?
            Tragen Sie sich kostenlos ein.
          </p>

          <a
            href='https://interaktiv.tagesanzeiger.ch/2020/zurich-hilft-erfassen/?nosome'
            className='ui primary button'
          >
            Eintrag anlegen
          </a>

          <h2>Ich brauche keine Hilfe mehr</h2>
          <p>
            Schreiben Sie uns ein E-Mail an{' '}
            <a href='mailto:simon.huwiler@tages-anzeiger.ch'>
              simon.huwiler@tages-anzeiger.ch
            </a>{' '}
            und wir entfernen Sie von dieser Karte.
          </p>
        </div>
      </div>

      <div
        id='mapcontainer'
        style={{ visibility: features.length > 0 ? 'visible' : 'hidden' }}
      >
        <div className='mapfader' />
        <AnimatedMap
          getMapObject={m => setMap(m)}
          mapReady={m => {
            m.on('click', 'data', e => setActiveFeature(e.features[0]))
            setMapReady(true)
          }}
        />
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        hideUserFeedback
        credits={[['Entwicklung', 'Simon Huwiler']]}
      />
    </div>
  )
}
